"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var core_1 = require("@angular/core");
require("./confirm-dialog.component.scss");
var material_1 = require("@angular/material");
var ConfirmDialogComponent = /** @class */ (function () {
    function ConfirmDialogComponent(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
    }
    ConfirmDialogComponent = tslib_1.__decorate([
        core_1.Component({
            selector: 'nano-confirm-dialog',
            template: require('./confirm-dialog.component.html')
        }),
        tslib_1.__param(1, core_1.Inject(material_1.MAT_DIALOG_DATA)),
        tslib_1.__metadata("design:paramtypes", [material_1.MatDialogRef, Object])
    ], ConfirmDialogComponent);
    return ConfirmDialogComponent;
}());
exports.ConfirmDialogComponent = ConfirmDialogComponent;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uZmlybS1kaWFsb2cuY29tcG9uZW50LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiY29uZmlybS1kaWFsb2cuY29tcG9uZW50LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLHNDQUFrRDtBQUVsRCwyQ0FBeUM7QUFDekMsOENBQWtFO0FBTWxFO0lBRUksZ0NBQW1CLFNBQStDLEVBQ3RCLElBQVM7UUFEbEMsY0FBUyxHQUFULFNBQVMsQ0FBc0M7UUFDdEIsU0FBSSxHQUFKLElBQUksQ0FBSztJQUNyRCxDQUFDO0lBSlEsc0JBQXNCO1FBSmxDLGdCQUFTLENBQUM7WUFDUCxRQUFRLEVBQUUscUJBQXFCO1lBQy9CLFFBQVEsRUFBRSxPQUFPLENBQUMsaUNBQWlDLENBQUM7U0FDdkQsQ0FBQztRQUllLG1CQUFBLGFBQU0sQ0FBQywwQkFBZSxDQUFDLENBQUE7aURBRE4sdUJBQVk7T0FGakMsc0JBQXNCLENBS2xDO0lBQUQsNkJBQUM7Q0FBQSxBQUxELElBS0M7QUFMWSx3REFBc0IifQ==


//////////////////
// WEBPACK FOOTER
// ./src/app/user-selection/confirm-dialog/confirm-dialog.component.ts
// module id = 277
// module chunks = 0